import axios from "axios";
const panelXios = axios.create({
  baseURL: process.env.VUE_APP_API_BASE_URL,
});
panelXios.defaults.headers.common["Content-Type"] = "application/json";
panelXios.defaults.headers.common["Authorization"] =
  "Bearer " + localStorage.panelToken;
// import alert from "@/plugins/AlertMessages.js";

export default {
  // JobAdvertisement Clinet Actions -------------------------------------------------------------------------------

  getDegree({ dispatch, commit }) {
    axios
      .get("client/Degree")
      .then((res) => {
        commit("setDegree", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getCollaborationType({ dispatch, commit }) {
    axios
      .get("client/CollaborationType")
      .then((res) => {
        commit("setCollaborationType", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getCompanyField({ dispatch, commit }) {
    axios
      .get("client/CompanyField")
      .then((res) => {
        commit("setCompanyField", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getSocialNetwork({ dispatch, commit }) {
    axios
      .get("client/SocialMedia")
      .then((res) => {
        commit("setSocialNetwork", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },
  // JobRequest Actions -------------------------------------------------------------------------------
  getJobRequest({ dispatch, commit }, data) {
    panelXios
      .get("client/JobRequest?" + data)
      .then((res) => {
        commit("setJobRequest", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getJobRequestById({ dispatch, commit }, data) {
    panelXios
      .get("client/JobRequest/" + data)
      .then((res) => {
        commit("setJobRequestById", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  // .................. Job Advertisement ...........................................
  getJobAdvertisement({ dispatch, commit }, data) {
    panelXios
      .get("client/JobAdvertisement?" + data)
      .then((res) => {
        commit("setJobAdvertisement", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },
  getJobAdvertisementById({ dispatch, commit }, data) {
    panelXios
      .get("client/JobAdvertisement/" + data)
      .then((res) => {
        commit("setJobAdvertisementById", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },
};
